module.exports = __webpack_public_path__ + "static/social-distancing-43955bcf3616b484fbafb3eabed2013c.png";